export enum ExpenseType {
    Abstract_Fees = 'Abstract Fees',
    Bank_Charges = 'Bank Charges',
    Copies = 'Copies',
    Discount = 'Discount',
    Draft_Ext = 'Draft Ext.',
    Fax = 'Fax',
    Forms_And_Supplies = 'Forms and Supplies',
    Maps = 'Maps',
    Notary = 'Notary',
    Office_Copies = 'Office Copies',
    Other = 'Other',
    Phone = 'Phone',
    Postage = 'Postage',
    Record_Fee = 'Record Fee',
    Shipping_Expense = 'Shipping Expense',
    Supplies = 'Supplies',
}



// WEBPACK FOOTER //
// ./src/models/AP/ExpenseType.ts